import { WorkspacePlan } from '@up2stay/up2promo-api-client';
import { Button } from '@up2stay/up2promo-ui';
import { Alert, AlertDescription } from '@up2stay/up2promo-ui';
import { X } from 'lucide-react';

import { canPurchaseBillingInApp } from '@/core/billing/can-purchase-billing-in-app';
import { useEntitlementLabels } from '@/core/components/billing/upgrade-surfaces';
import { useStartCheckout } from '@/core/hooks/use-billing';
import { useDictionary } from '@/core/providers/dictionary-provider';
import { usePendingUpgradeStore } from '@/core/store/pending-upgrade.store';
import { useCurrentWorkspace } from '@/core/store/workspace.store';

export function PendingUpgradeBanner() {
  const dict = useDictionary();
  const bannerDict = dict.workspace.billing.pendingUpgrade;
  const workspace = useCurrentWorkspace();
  const pending = usePendingUpgradeStore((s) =>
    workspace?.id ? s.getPending(workspace.id) : undefined,
  );
  const clearPending = usePendingUpgradeStore((s) => s.clearPending);
  const { getPlanLabel } = useEntitlementLabels();
  const startCheckout = useStartCheckout();

  if (!canPurchaseBillingInApp()) return null;
  if (!workspace?.id || !pending) return null;
  if (
    pending.plan === WorkspacePlan.FREE ||
    pending.plan === WorkspacePlan.ENTERPRISE
  ) {
    return null;
  }

  const planLabel = getPlanLabel(pending.plan);

  return (
    <Alert className="relative border-primary/30 bg-primary/5">
      <AlertDescription className="flex flex-col gap-3 pr-8 sm:flex-row sm:items-center sm:justify-between">
        <span>{bannerDict.message.replace('{plan}', planLabel)}</span>
        <Button
          size="sm"
          variant="primary"
          disabled={startCheckout.isPending}
          onClick={() =>
            startCheckout.mutate({
              plan: pending.plan,
              billingCycle: pending.billingCycle,
              workspaceId: workspace.id,
            })
          }
        >
          {bannerDict.cta.replace('{plan}', planLabel)}
        </Button>
      </AlertDescription>
      <button
        type="button"
        className="absolute right-3 top-3 text-muted-foreground hover:text-foreground"
        aria-label={bannerDict.dismiss}
        onClick={() => clearPending(workspace.id)}
      >
        <X className="h-4 w-4" />
      </button>
    </Alert>
  );
}
